module.exports = __webpack_public_path__ + "static/img/14.d240cd1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/eng/14.png
// module id = Z4h9
// module chunks = 0